import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { LoginService } from '../home/login.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ProductService } from '../products/products.service';
import { AppComponent } from '../app.component';
import { PasswordValidation } from '../account/password-validation';
import { Subscription } from 'rxjs';
import { IRep } from '../home/rep';
import { ToastrService } from 'ngx-toastr';
import { APIResult } from '../home/apiResult';
import { IRepPublicData } from '../home/repPublicData';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  standalone: false,
  templateUrl: './validatekey.component.html',
})
export class ValidateResetComponent implements OnInit {
  public pageTitle: string = 'Password Reset';
  rep!: IRepPublicData;
  public tempRepId!: string;
  public apiResult!: APIResult;
  errorMessage!: string;
  private sub!: Subscription;
  public caption: string;
  public transErrMsg: string;
  translatedText = '';

  constructor(
    private _loginService: LoginService,
    public fb: FormBuilder,
    private _productService: ProductService,
    private _route: ActivatedRoute,
    private _router: Router,
    public app: AppComponent,
    private toaster: ToastrService,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService
  ) {}
  public resetForm = this.fb.group(
    {
      //resetKey: ['', Validators.required],
      custPass: ['', Validators.required],
      custPass2: ['', Validators.required],
    },
    {
      validator: PasswordValidation.MatchPassword,
    }
  );
  public options = {
    position: ['bottom', 'right'],
    timeOut: 6000,
    lastOnBottom: true,
    preventDuplicates: false,
    preventLastDuplicates: false,
  };

  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              }
            );
          }
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          }
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }
  validate(): any {
    var resetEmail = JSON.parse(localStorage.getItem('resetEmail') || '{}');
    var myKey = JSON.parse(localStorage.getItem('resetKey') || '{}');
    var custDID = JSON.parse(localStorage.getItem('customerDID') || '{}');
    //console.log(resetEmail);
    this._loginService
      .validateKey(custDID, myKey, this.resetForm.controls['custPass'].value)
      .subscribe(
        (res) => {
          this.apiResult = res;
        },
        (error) => this.resetError(),
        () => {
          //when successful do this stuff
          this._loginService
            .passReset(
              custDID,
              myKey,
              this.resetForm.controls['custPass'].value
            )
            .subscribe(
              (res) => {
                this.apiResult = res;
              },
              (error) => this.errorMessage,
              () => {
                this.resetSuccess();

                setTimeout((router: Router) => {
                  this._router.navigateByUrl('login');
                }, 7000);
              }
            );
          // success message here and then re route
          // setTimeout((router: Router) => {
          //     this._router.navigateByUrl('shop/from/' + this.repId());
          // }, 2000);
        }
      );
  }
  resetError(): void {
    this.toaster.error(
      'Your password reset link has exipred',
      'Expired Reset Link',
      {
        timeOut: 3000,
      }
    );
  }
  resetSuccess(): void {
    this.toaster.success('Your password has been reset', 'Success', {
      timeOut: 3000,
    });
  }
  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }

  ngOnInit(): void {
    // this._loginService.refreshToken()
    // .subscribe()
    //this._loginService.getCustomerDID()

    this.sub = this._route.params.subscribe((params) => {
      let id = +params['id:key'];
      this._loginService.getCustomerInfoForReset(id.toString()).subscribe(
        (rep) => {
          console.log(rep);
          this.tempRepId = rep.toString();
          //localStorage.setItem('repId', rep.toString());
        },
        (error) => console.log(error),
        () => {
          this._productService.getRepInfo(this.tempRepId).subscribe((rep) => {
            this.rep = rep;
            this.app.rep = rep;
            console.log('made it');
          });
        }
      );
      // this._productService.getRepInfo(id.toString()).subscribe(rep => {
      //     this.rep = rep;
      //     this.app.rep = rep;
      // });
      //console.log(id.toString());

      //localStorage.setItem('repId', id.toString());
    });

    this.sub = this._route.queryParams.subscribe((params) => {
      // Defaults to 0 if no query param provided.
      let key = params['key'];
      //console.log(key.toString());
      localStorage.setItem('resetKey', JSON.stringify(key.toString()));

      var storedKey = localStorage.getItem('resetKey');

      console.log(storedKey);
      //console.log(id);
    });
  }
}
